import { form } from "./form";

const {
  formField: {
    endpointUrl,
    method,
    credentials,
    credentialType,
    credentialName,
    username,
    password,
    token,
    required,
    respond,
    node,
    additionalOptions,
    // requestHeaders,
    responseCode,
    customResponseCode,
    responseHeaders,
    formData,
    payloadContentType,
    payload,
    allowedOrigins,
    notes,
    returnConsoleLog,
    topics,
  },
} = form;

const initialValues = {
  [endpointUrl.name]: "",
  [method.name]: ["GET"],
  [credentials.name]: "",
  [credentialName.name]: "",
  [credentialType.name]: "",
  [username.name]: "",
  [password.name]: "",
  [token.name]: "",
  [required.name]: false,
  [respond.name]: "",
  [additionalOptions.name]: [],
  // [requestHeaders.name]: [],
  [responseCode.name]: [],
  [customResponseCode.name]: "",
  [responseHeaders.name]: [],
  [payloadContentType.name]: "",
  [formData.name]: [],
  [payload.name]: "",
  [allowedOrigins.name]: "",
  [node.name]: "",
  [notes.name]: "",
  [returnConsoleLog.name]: false,
  [topics.name]: [],
};

export default initialValues;
